import React from 'react';
import { Card } from '@material-tailwind/react';

const Profile = ({ image, name, titles }) => {
  return (
    <Card className='h-96 w-72 max-w-xs bg-cream shadow-lg rounded-lg'>
            <Card.Body className='text-center'>
            <img 
              className='mx-auto md:my-auto my-5 w-48 p-5 rounded-full h-48 object-cover'
              src={image} alt='Profile' />
        <h3 className='font-extrabold text-xl mb-1'>{name}</h3>
        {titles.map((element) => {
          return <h4 key={element}>{element}</h4>;
        })}
      </Card.Body>
    </Card>
  );
};

export default Profile;
